import React, { Component } from 'react';
import { AuthContext } from "./../../context/auth";
import { Link } from "react-router-dom";

class TopNavForgotPasswordComponent extends Component{
    handleGoBack = () => {
        return this.props.history.length > 2 ? this.props.history.goBack() : this.props.history.push(`${process.env.PUBLIC_URL}/`)
    }

    static contextType = AuthContext;
    render(){
        return (
            <div className="inner-navbar">
                <div className="container">

                    <div className="inner-navbar-fit">
                        <button onClick={this.handleGoBack} className="arrow-left"><i className="fa fa-chevron-left d-none"
                                                          aria-hidden="true"></i><img src={`${process.env.PUBLIC_URL}/image/back_white.png`} alt=""/>
                        </button>
                        <h1 className="text-hide">
                            <Link to={`${process.env.PUBLIC_URL}/`} className="logo-link logo-replacement"
                                  style={{backgroundImage: "url('"+process.env.PUBLIC_URL+"/image/silverback-logo-text.png')"}}></Link>
                            Host4VIP
                        </h1>
                    </div>
                </div>
            </div>
        );
    }
}

export default TopNavForgotPasswordComponent;